
import { imagesArch } from "./imagesArch.js";
import { imagesBat } from "./imagesBat.js";
import { imagesDev } from "./imagesDev.js";
import { imagesServices } from "./imagesServices.js";

export const en = {
  home: "/",
  locale: "en",
  localeNav: "/en",
  archNav: "architecture",
  servicesNav: "services",
  batNav: "building",
  devNav: "development",
  archTitle: "Architecture",
  archTitle2: "My Architectural Projects",
  batTitle: "Building",
  batTitle2: "My Achievements",
  batTitle3: "The work was carried out largely on my own, either supervised by an apprentice",
  batTitle4: "A true professional is capable of creating works of art, equipped with a set of tools and a few power tools.",
  servicesTitle: "Services",
  devTitle: "Development web",
  devTitleNav: "Development",
  devTitle2: "Development of applications for personal use",
  comments: "Comments",
  iLike: "I Like",
  comment: "Comment",
  share: "Share",
  discoverProject: "Discover the project...",
  footer_p1: "Boogysh. All right reserved.",
  footer_p2: "Updated:",
  identity: "Identity",
  lastName: "Last Name",
  firstName: "First Name",
  birthDay: "Birth Day",
  birthPlace: "Birth Place",
  countryOfBirth: "Country of Birth",
  country: "R. of Moldova",
  nationalities: "Nationalities",
  nationalities_val: "Moldavian and Romanian",
  ssNumber: "S.S. Number",
  adress: "Address",
  tel: "Telephone",
  email: "E-mail",
  civilStatus: "Civil Status",
  civilStatus_val: "Married, two children.",
  studies: "Studies and Degrees",
  school: "General School MERENI",
  highSchool:
    "Real University Republican High School, Physics-Mathematics Profile",
  bac: "Bachelor's degree",
  college:
    "Technical University of Moldova, Faculty of Urbanism and Architecture Speciality:Engineering Urban Planning",
  master: "Master: Civil Construction Engineering",
  master_stopped:
    "Interrupted, the profile did not correspond to the desired program, too far from the Architecture",
  archicad_3dsMax: "Training AUTOCAD, ARCHICAD, 3DS MAX",
  devWeb: "Web Developer, Openclassrooms",
  devWeb_val: "Level 5 degree (bac +2)",
  experience: "Experience",
  internship_1: "Internship planning “IGC CONSTRUCT”",
  internship_2: "Internship preparation Degree “IGC CONSTRUCT”",
  apprenticeship: "Apprenticeship “IGC CONSTRUCT”",
  armanda: "Non-salaried activity : Company “Armanda”, 75012 Paris",
  armanda_2: "Director : Company “Armanda” 75012 Paris",
  catalan: "Non-salaried activity Multi-tasking Company “Catalan Building”.",
  heres: "Company “Hères Construction”",
  heres_val: "Team leader, many teams leader, Site manager",
  dev: "Application Developer - JavaScript React",
  dev_info: " Development of applications for personal use",
  renovation: "Renovation of residential homes",
  characteristics: "Characteristics",
  characteristics_val:
    "Responsibility, Commitment, Punctuality, Sociability, Ability to work with customers to find an individual solution. Ability to work in a team, fast and efficient. Ability to evaluate situations, to overcome obstacles and to take actions (solutions) that correspond. Ability and willingness to learn new areas quickly and efficiently.",
  software: "Software",
  advenced: "advenced",
  medium: "medium",
  basic: "basic",
  dev_Technologies: "Development technology",
  install: "Installation & Maintenance",
  install_val: "WINDOWS, Software and Office Equipment.",
  languages: "Languages",
  rom_mold: "Romanian/Moldavian",
  french: "French",
  native: "native",
  russian: "Russian",
  english: "English",
  writtenExpression: "written expression (code and commentary in English)",
  writtenComprehension:
    "written comprehension (average), oral comprehension (average), oral expression (beginner)",
  driver_sLicense: "Driver's license",
  driverCategory: "Category B",
  download: "Download",
  cardArch: [{
  id: "pr3-stade",
  title: "Training center for law enforcement officers",
  description: "It is a project for law enforcement officers, equipped with a soccer field for 2300 spectators, a volleyball court, a basketball court, a 25m swimming pool, a tennis court, several boxing and fighting rooms, a fitness room etc.",
  info: ["Stadium: 2600 spectators.","Spaces: Basketball, Voley, Tennis, Box, Shooting, Paintball, Fitness.","Swimming pool: 25m, 6 lanes.","Rest: Sauna, Therapy, Restaurant.","Parking: 360 cars."],
  technos: ["react","tailwind","node","mongoDB"],
  cover: imagesArch["pr3-stade"].cover,
  pictures: imagesArch["pr3-stade"].pictures
},
{
  id: "pr-maison-perso",
  title: "Single-family home v-2024",
  description: "House for a family with 3-4 children. The photos are renderings created using 3D'S MAX + V-ray.",
  info: ["Stone house.","For a family of 5-6 people.","Ground floor: living room, dining room, kitchen, one bedroom","Ground floor: bathroom, laundry room, and garage","Upstairs: 3 bedrooms and bathroom facilities. "],
  technos: ["react","tailwind","node","mongoDB"],
  cover: imagesArch["pr-maison-perso"].cover,
  pictures: imagesArch["pr-maison-perso"].pictures
},
{
  id: "pr1-maison",
  title: "Single family house P+S (Ground floor + attic).",
  description: "Single family house (ground floor + attic) for a family with 3-4 children. The photos are renders made with 3D'S MAX + V-ray.",
  info: ["Limestone block house.","For a family of 5 - 6 persons.","Basements: gym and storage room.","Ground floor: kitchen, dining room, living room, office, toilet block.","Floor: 4 bedrooms and sanitary block."],
  technos: ["react","tailwind","node","mongoDB"],
  cover: imagesArch["pr1-maison"].cover,
  pictures: imagesArch["pr1-maison"].pictures
},
{
  id: "pr2-maison",
  title: "The house, inspired by a fairy tale",
  description: "This house with unusual characteristics is still quite well known. The most difficult thing is to systematize the space in order to transform it into a habitable dwelling.",
  info: ["Limestone block house.","For a family of 4 - 5 persons.","Known project, completely adapted to the daily needs.","Ground floor: Kitchen, dining room, living room, WC.","Floor: 3 bedrooms, bathroom."],
  technos: ["react","tailwind","node","mongoDB"],
  cover: imagesArch["pr2-maison"].cover,
  pictures: imagesArch["pr2-maison"].pictures
},
{
  id: "pr3A-maison",
  title: "Single-family home v-2023",
  description: "Personal project",
  info: ["Stone or hollow block house.","For a family of 4 - 5 persons.","Known project, completely adapted to the daily needs.","Ground floor: Kitchen, dining room, living room, WC. bathroom.","Floor: 3 bedrooms, bathroom."],
  technos: ["react","tailwind","node","mongoDB"],
  cover: imagesArch["pr3A-maison"].cover,
  pictures: imagesArch["pr3A-maison"].pictures
},
{
  id: "pr4-cinema",
  title: "Boogysh Cinema",
  description: "The Boogysh Cinema project represents the solution to problems such as: sound physics, visibility calculation, respecting the rules of the art.",
  info: ["Cinema room, 24m long, 5 sectors.","Capacity 528 places.","Visibility calculation, insured.","Restaurants.","Rooms for the administration."],
  technos: ["react","tailwind","node","mongoDB"],
  cover: imagesArch["pr4-cinema"].cover,
  pictures: imagesArch["pr4-cinema"].pictures
},
{
  id: "pr5-reconstruction",
  title: "Reconstruction of a 4 level building",
  description: "The consolidation of the foundations to add a level and a mansard.",
  info: ["Existing: Building in 4 levels, first floor + 3 floors.","Addition of an extra floor and a mansard.","Calculates for each type of foundation.","Foundation consolidation, each sector 3m length."],
  technos: ["react","tailwind","node","mongoDB"],
  cover: imagesArch["pr5-reconstruction"].cover,
  pictures: imagesArch["pr5-reconstruction"].pictures
},
{
  id: "pr6-urbanime",
  title: "Urban planning",
  description: "Detailed urban plan of a neighborhood for 5000 inhabitants.",
  info: ["Area for 5000 inhabitants.","A preschool.","Landscaped areas: For children 3-7 years.","Landscaped areas: For children 7-12 years.","Green areas."],
  technos: ["react","tailwind","node","mongoDB"],
  cover: imagesArch["pr6-urbanime"].cover,
  pictures: imagesArch["pr6-urbanime"].pictures
},
{
  id: "pr7-sistematisation-verticale",
  title: "Vertical systematization",
  description: "Vertical systematization of a neighborhood with the adjacent arterial road.",
  info: ["Identify level lines on the plan.","According to the level lines, arrange a territory with buildings and project an elongated cloverleaf type intersection.","Determine the level '0' of each building.","Show the cross section of the road."],
  technos: ["react","tailwind","node","mongoDB"],
  cover: imagesArch["pr7-sistematisation-verticale"].cover,
  pictures: imagesArch["pr7-sistematisation-verticale"].pictures
}],
  cardBat: [{
  id: "pr1-terasse",
  title: "Creation of a travertine terrace and renovation of the pool.",
  description: undefined,
  info: ["Realization of a 6 to 12 cm layer.","The installation of travertine ep. 2cm with a pattern of 4 pieces.","The installation of the pool border thickness 5cm.","Swimming pool - installation of the mosaic 4.5cm x 4.5cm, epoxy glue.","Application of the two layers of protection on the stone."],
  technos: ["react","tailwind","node","mongoDB"],
  cover: imagesBat["pr1-terasse"].cover,
  pictures: imagesBat["pr1-terasse"].pictures
},
{
  id: "renovation_totale",
  title: "Total renovation of an apartment",
  description: undefined,
  info: ["Demolition and evacuation of the rubble.","Realization of all the partitions in Placostil.","Installation of woodwork.","Electricity and plumbing.","Plastering and painting.","Patch up and electric floor heating.","Gluing of tiles in the kitchen and bathrooms.","Glued installation of massif parquet in the rooms."],
  technos: ["react","tailwind","node","mongoDB"],
  cover: imagesBat["renovation_totale"].cover,
  pictures: imagesBat["renovation_totale"].pictures
},
{
  id: "renovation_maison",
  title: "Renovation of a house",
  description: undefined,
  info: ["Bringing electrical systems up to standard","Plastering and painting","Floor leveling","Installation of floating parquet flooring on the ground floor, suitable for damp rooms","IKEA kitchen cabinet design and installation","Laying floating parquet flooring in upstairs rooms","Laying tiles in toilets and bathrooms","Single-flow CMV replacement","Modification of plumbing","New hot water tank","Pouring a 12cm thick slab on the terrace"],
  technos: ["react","tailwind","node","mongoDB"],
  cover: imagesBat["renovation_maison"].cover,
  pictures: imagesBat["renovation_maison"].pictures
},
{
  id: "consolidation_maison",
  title: "Foundation reinforcement",
  description: undefined,
  info: ["Digging all over the house","Digging under the foundations","Reinforcement of the entire structure","Concrete pouring","Application of the sealant in two layers","Backfill with soil","Backfill with topsoil","Lawn restoration"],
  technos: ["react","tailwind","node","mongoDB"],
  cover: imagesBat["consolidation_maison"].cover,
  pictures: imagesBat["consolidation_maison"].pictures
},
{
  id: "ouvertures",
  title: "Creation of openings",
  description: undefined,
  info: ["Calculation of transmitted weight from walls, floor and roof.","Calculation and dimensioning of metal profiles.","Realization of the lintels in two stages.","Realization of the jambs in reinforced concrete.","Realization of the opening and evacuation of the rubble.","Realization of a support or threshold in reinforced concrete.","The installation of the joinery in accordance with DTU.","Roughing and coating of the frames."],
  technos: ["react","tailwind","node","mongoDB"],
  cover: imagesBat["ouvertures"].cover,
  pictures: imagesBat["ouvertures"].pictures
},
{
  id: "extension",
  title: "Realization of an extension. Structural work.",
  description: undefined,
  info: ["Realization of the foundations in reinforced concrete depth 1.2m.","Ground floor with polystyrene slabs and reinforced concrete.","Construction of the walls in 20cm concrete blocks.","Facade built with traditional masonry.","Framing with appropriate fittings.","Reinforced concrete band and columns.","The roof and the skylight are covered with flat tiles."],
  technos: ["react","tailwind","node","mongoDB"],
  cover: imagesBat["extension"].cover,
  pictures: imagesBat["extension"].pictures
},
{
  id: "isolation-placo",
  title: "Insulation of exterior walls",
  description: undefined,
  info: ["Structure made with R48 and M48 rails and mounts.","GR32 mineral wool with thickness of 120mm.","Waterproofing membrane.","Placo BA13 normal/hydro/phonic/fireproof."],
  technos: ["react","tailwind","node","mongoDB"],
  cover: imagesBat["isolation-placo"].cover,
  pictures: imagesBat["isolation-placo"].pictures
},
{
  id: "assainissement",
  title: "Sanitation and drainage",
  description: undefined,
  info: ["Realization of the trenches with a level difference 2cm for each meter.","Gluing of PVC pipes diametre 100mm for each future evacuation.","Connection outside of the house in a manhole.","Installation of a 40x40 manhole with an associated concrete pad.","Drainage system with 5 lengths and a surface of 100 sq.m."],
  technos: ["react","tailwind","node","mongoDB"],
  cover: imagesBat["assainissement"].cover,
  pictures: imagesBat["assainissement"].pictures
}],
  cardDev: [{
  id: "pr12-fiche-eye",
  title: "Fiche-eye",
  urlProject: "https://fich-eye.vercel.app/",
  info: ["Create a site for phographers","Liker images using the local storage","Creating a slider","Sort photos by popularity, date o","Complete and validate the contact form","Send the message to database mongoDB"],
  technos: ["html","css","js","node","mongoDB"],
  cover: imagesDev["pr12-fiche-eye"].cover,
  pictures: imagesDev["pr12-fiche-eye"].pictures
},
{
  id: "pr11-moteur-recherche",
  title: "Create a search engine application",
  urlProject: "https://les-petits-plat.vercel.app/",
  info: ["Create a search engine with two axes","Create tags for each searched value","Search in Ingredients, Appliances and Utensils","Show the intersection of search result","Display a personalized message for a null result"],
  technos: ["html","css","js"],
  cover: imagesDev["pr11-moteur-recherche"].cover,
  pictures: imagesDev["pr11-moteur-recherche"].pictures
},
{
  id: "pr10-social-media",
  title: "Create a social network web application",
  urlProject: "https://sm-boogysh.vercel.app/",
  info: ["Use of redux and react-redux, MongoDB and S3-AWS.","View the visitors list of the user's page.","Dark-mode and search button for registered users.","Backend to manage requests GET, POST, PATCH, DELETE","Save and delete files on S3-AWS and URLs on MongoDB.","View the entire application online with Vercel."],
  technos: ["react","tailwind","redux","node","mongoDB","aws"],
  cover: imagesDev["pr10-social-media"].cover,
  pictures: imagesDev["pr10-social-media"].pictures
},
{
  id: "pr9-netflix-youtube",
  title: "Créez une application type netflix",
  urlProject: "https://boogysh-flix.vercel.app",
  info: ["Use of redux and react-redux, MongoDB.","Backend to manage requests GET, POST, PATCH, DELETE","Integrate themoviedb-api and youtube-api.","Save movies to favorites.","Generate and view the movie trailer dynamically.","View the entire application online with Vercel."],
  technos: ["react","tailwind","redux","node","mongoDB","themoviedb","youtube"],
  cover: imagesDev["pr9-netflix-youtube"].cover,
  pictures: imagesDev["pr9-netflix-youtube"].pictures
},
{
  id: "pr8-castle",
  title: "Créez une application web avec des éléments e-commerce",
  urlProject: "https://castle-boogysh.vercel.app/",
  info: ["Utilisation du redux et react-redux.","Réalisation d'un backend pour gérer les requêtes GET, POST.","Utilisation de la BD MongoDB et mongoose.","Envoyer les messages et les commandes sur la base de données.","Recherche des commandes avec l'email où le numéro de la commande.","Afficher l'ensamble de l'aplication en ligne avec Vercel."],
  technos: ["react","css","redux","node","mongoDB"],
  cover: imagesDev["pr8-castle"].cover,
  pictures: imagesDev["pr8-castle"].pictures
},
{
  id: "pr7-kasa",
  title: "Create a propery rental web application with React",
  urlProject: "https://boogysh.github.io/kasa/",
  info: ["Cutting into modular and reusable components.","Configure navigation between pages with React Router.","Using the props between the components.","Using the state in components when necessary.","Event management.","The 404 page is returned for each non-existent route, or there is a mistake in the URL."],
  technos: ["react","css"],
  cover: imagesDev["pr7-kasa"].cover,
  pictures: imagesDev["pr7-kasa"].pictures
},
{
  id: "pr6-api-piquante",
  title: "Build a secure API for a food review application",
  urlProject: "https://github.com/boogysh/piquante",
  info: ["All routes have a typical authorization: Bearer <token>.","The user's password is hashed.","The email address in the MongoDB database is unique (mongoose-unique-validator).","The user is checked if he is allowed to modify or delete a sauce.","Colect the errors from the database, through personalized error messages."],
  technos: ["node","mongoDB"],
  cover: imagesDev["pr6-api-piquante"].cover,
  pictures: imagesDev["pr6-api-piquante"].pictures
},
{
  id: "pr5-eCommerce",
  title: "Build an e-commerce site in JavaScript",
  urlProject: "https://github.com/boogysh/kanap",
  info: ["Managing JavaScript events.","Interact with a web service with JavaScript.","Validate data from external sources.","Create a test plan for an application."],
  technos: ["js"],
  cover: imagesDev["pr5-eCommerce"].cover,
  pictures: imagesDev["pr5-eCommerce"].pictures
},
{
  id: "pr4-SEO",
  title: "Optimize an existing website:",
  urlProject: "https://boogysh.github.io/La-panthere/",
  urlExistent: "https://boogysh.github.io/la-panthere_initial/",
  info: ["Use a custom domain.","Optimize the size and speed of a website.","Research the best practices in web development.","Write maintainable HTML and CSS code.","Ensure the accessibility of a website.","Optimize the referencing of a website."],
  technos: ["html","css","js"],
  cover: imagesDev["pr4-SEO"].cover,
  pictures: imagesDev["pr4-SEO"].pictures
},
{
  id: "pr3-ohmyfood",
  title: "Make a web page dynamic with CSS animations",
  urlProject: "https://boogysh.github.io/OCR_PR3/",
  info: ["Use a version control system for project versioning and hosting.","Set up its frontend environment.","Ensure the graphic consistency of a website.","Set up a navigation structure for a website.","Implement advanced graphic CSS effects."],
  technos: ["html","sass"],
  cover: imagesDev["pr3-ohmyfood"].cover,
  pictures: imagesDev["pr3-ohmyfood"].pictures
},
{
  id: "pr2-booki",
  title: "Turn a mock-up into a website with html and css",
 urlProject: "https://boogysh.github.io/booki/",
  info: ["Cutting of the mock-up.","Creation of the accommodation page.","Creation of the activities page.","Use semantic tags.","Development of the responsive part.","Validation of the code with the W3C."],
  technos: ["html","css"],
  cover: imagesDev["pr2-booki"].cover,
  pictures: imagesDev["pr2-booki"].pictures
}],
  cardServices: [{
  id: "second_oeuvres",
  title: "Finishing work",
  description: undefined,
  info: ["Installation of screeds and leveling compounds","Thermal and sound insulation","Installation of interior woodwork","Placostil partitions and plasterboard","Plaster and paint","Glued and floating parquet flooring","Waterproofing, Tiling, and Wall Failure","Electrical and plumbing connections","Assembly and installation of furniture"],
  technos: ["react","tailwind","node","mongoDB"],
  cover: imagesServices["second_oeuvres"].cover,
  pictures: imagesServices["second_oeuvres"].pictures
},
{
  id: "gros_oeuvres",
  title: "Structural work",
  description: undefined,
  info: ["Creation of openings","Installation of exterior joinery","Small earthworks with difficult access for machinery","Construction of 12cm thick slabs and terraces.","Build walls","Sewer connection as part of renovation work","Foundation reinforcement"],
  technos: ["react","tailwind","node","mongoDB"],
  cover: imagesServices["gros_oeuvres"].cover,
  pictures: imagesServices["gros_oeuvres"].pictures
}]
};
